module.exports = __webpack_public_path__ + "img/download.65254610.svg";